import React from 'react';

/**
 * FlowConnector - Animated vertical dashed line connecting stages
 *
 * @param {boolean} animated - Whether to animate the dashes flowing down
 * @param {string} height - CSS height value (default: '40px')
 * @param {boolean} branching - Whether this connector branches (shows arrow)
 */
const FlowConnector = ({ animated = true, height = '40px', branching = false }) => {
  return (
    <div
      className={`flow-connector ${animated ? 'flow-connector--animated' : ''}`}
      style={{ height }}
    >
      <div className="flow-connector__line" />
      {branching && <div className="flow-connector__arrow" />}
    </div>
  );
};

export default FlowConnector;
